import { FC } from 'react'
import { Link } from 'react-router-dom'
import { css, styled } from 'styled-components'
import { ISideMenuItem } from '.'
import { Text } from '@tuhi/components'
import { contentColorStyle } from '@tuhi/components/src/redesign/buttons/button'
import { media } from '@tuhi/components/src/theme/breakpoints'

export const menuItemStyle = css<{ $isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    line-height: 30px;
    padding: 10px 16px;
    border-radius: 4px;
    border: 1px solid transparent;
    text-decoration: none;
    gap: 10px;
    justify-content: ${(p) => (p.$isCollapsed ? 'center' : 'start')};

    ${(p) => contentColorStyle(p.theme.colors.tertiary.tertiary900)}

    ${media.tablet} {
        justify-content: center;
    }
`

export const MenuItemLabel = styled.span`
    ${media.tablet} {
        display: none;
    }
`

const menuStyles = {
    selected: css`
        background-origin: border-box;
        background-clip: padding-box, border-box;
        background-image: ${(p) =>
            `linear-gradient(${p.theme.colors.primary.green100}, ${p.theme.colors.primary.green100}), linear-gradient(261.9deg, rgba(179, 217, 200, 0.4) 6.92%, rgba(10, 132, 71, 0.4) 146.46%)`};

        ${(p) => contentColorStyle(p.theme.colors.primary.default)}

        &:hover {
            background-color: 'auto';
        }
    `,
    default: css`
        &:hover {
            background-color: ${(p) => p.theme.colors.tertiary.tertiary50};
        }
    `,
}

export const MenuItem = styled(Link)<{
    $isCollapsed: boolean
    $isSelected?: boolean
}>`
    ${menuItemStyle}

    ${(props) => menuStyles[props.$isSelected ? 'selected' : 'default']}
`

export interface SideMenuProps {
    menu: ISideMenuItem
    isSelected: boolean
    isCollapsed: boolean
    onNavigate?: () => void
}

export const PositiveMenuItem: FC<SideMenuProps> = ({
    menu,
    isSelected,
    isCollapsed,
    onNavigate,
}) => {
    const text = (
        <MenuItemLabel>
            <Text size="medium" $weight="medium" color="none">
                {menu.route.name}
            </Text>
        </MenuItemLabel>
    )

    const handleClick = (e: React.MouseEvent) => {
        if (onNavigate) {
            e.preventDefault()
            onNavigate()
        }
    }

    return (
        <MenuItem
            to={menu.route.path}
            $isSelected={isSelected}
            $isCollapsed={isCollapsed}
            onClick={handleClick}
        >
            {menu.icon}
            {!isCollapsed ? text : <></>}
        </MenuItem>
    )
}
